import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { AtxStepper } from '@epicuro-next/ataraxia/stepper';
import {
  selectHideNeoclesLogo,
  selectHideTenantLogo,
  selectOnboardingSteps,
  setActiveOnboarding,
  setOnboardingViewed,
} from '@epicuro-next/state/onboarding';
import { selectCurrentSite } from '@epicuro-next/state/site-state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'epc-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OnboardingComponent {
  @ViewChild(AtxStepper)
  public stepper: AtxStepper;

  public currentSiteLogo$ = this.store.pipe(
    select(selectCurrentSite),
    map((currentSite) => currentSite?.logoUrl),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  public imageMaxSizes = IMAGE_MAX_SIZES;

  public onboardingSteps$ = this.store.pipe(select(selectOnboardingSteps));

  public hideNeoclesLogo$ = this.store.pipe(select(selectHideNeoclesLogo));

  public hideTenantLogo$ = this.store.pipe(select(selectHideTenantLogo));

  constructor(private modal: NgbActiveModal, private store: Store) {}

  public close() {
    this.store.dispatch(setOnboardingViewed());
    this.store.dispatch(setActiveOnboarding({ target: null }));
    this.modal.close();
  }
}
